export default {"src":"/_next/static/media/ETSY.57efed9a.svg","height":18,"width":18};